import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import type { RecordResponse } from '../models/ServiceTypes';

export type MasterSearchRecordType = 'account' | 'investor';

export interface MasterSearchRecord {
  Type: MasterSearchRecordType;
  TypeId: number;
  Id: number;
  Name: string;
  Balance: number;
  AccountNumber?: string | null;
  UserName?: string | null;
}

export interface MasterSearchQueryArg {
  searchTerm: string;
}

export const MASTER_SEARCH_MIN_CHARS = 2;
export const MASTER_SEARCH_REQUEST_LIMIT = 100;

export const masterSearchApi = createApi({
  reducerPath: 'masterSearchApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getAdvisorMasterSearch: builder.query<
      RecordResponse<MasterSearchRecord>,
      MasterSearchQueryArg
    >({
      query: ({ searchTerm }) => ({
        url: '/api/advisor/masterSearch',
        method: 'GET',
        params: {
          SearchTerm: searchTerm,
          'sort[0].Property': 'Name',
          'sort[0].Direction': 'asc',
          limit: MASTER_SEARCH_REQUEST_LIMIT,
        },
      }),
    }),
  }),
});

export const { useGetAdvisorMasterSearchQuery } = masterSearchApi;
